import React from "react";

export default function MachinesBaseEditor({ machines, onAdd, onUpdate, onRemove }) {
  return (
    <section className="swb-panel">
      <div className="swb-panel__head">
        <h3>Base de maquinas</h3>
        <button type="button" className="swb-btn" onClick={onAdd}>
          Adicionar maquina
        </button>
      </div>

      <div className="swb-table-wrap">
        <table className="swb-table swb-table--compact">
          <thead>
            <tr>
              <th>Prefixo</th>
              <th>Numero</th>
              <th>Codigo (gerado)</th>
              <th>Media por hora</th>
              <th>Taxa aproveitamento (%)</th>
              <th>Acoes</th>
            </tr>
          </thead>
          <tbody>
            {(machines || []).map((machine) => (
              <tr key={machine.id}>
                <td>
                  <input
                    className="swb-mini-input"
                    type="text"
                    value={machine.prefix || ""}
                    onChange={(e) => onUpdate(machine.id, "prefix", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    className="swb-mini-input"
                    type="text"
                    value={machine.number || ""}
                    onChange={(e) => onUpdate(machine.id, "number", e.target.value)}
                  />
                </td>
                <td>{machine.code || "-"}</td>
                <td>
                  <input
                    className="swb-mini-input"
                    type="number"
                    min="0"
                    step="0.1"
                    value={machine.avgPerHour ?? 0}
                    onChange={(e) => onUpdate(machine.id, "avgPerHour", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    className="swb-mini-input"
                    type="number"
                    min="0"
                    max="120"
                    step="0.1"
                    value={machine.utilizationRate ?? 0}
                    onChange={(e) => onUpdate(machine.id, "utilizationRate", e.target.value)}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="swb-btn swb-btn--danger"
                    onClick={() => onRemove(machine.id)}
                  >
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
